import styled from 'styled-components';
import * as Cards from 'eCoach/_styles/Cards.style';
import * as Text from 'theme/components/Text.style';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';

interface StatusProps {
  status?: string;
}

export const Tabs = styled('div')`
  box-shadow: inset 0px -2px 0px ${colours.neutral[300]};
  display: flex;
  gap: 30px;
  height: 50px;
  margin-top: 0 !important;

  @media (max-width: ${breakpoints.tablet}) {
    gap: 10px;
    overflow-x: auto;
  }
`;

export const Tab = styled('div')`
  align-items: left;
  background-color: none;
  border-bottom: ${(props) =>
    props.isActive ? `2px solid ${colours.primary[500]}` : 'none'};
  cursor: pointer;
  display: flex;
  gap: 15px;
  padding: 0 5px;
  white-space: nowrap;

  h6 {
    color: ${(props) => (props.isActive ? colours.primary[500] : 'black')};
  }

  @media (max-width: ${breakpoints.tablet}) {
    align-items: center;
    background-color: ${(props) =>
      props.isActive ? `${colours.neutral[200]}` : 'none'};
    border-radius: 5px 5px 0 0;
    padding: 0 15px;
  }
`;

export const NewConvoButton = styled('div')`
  display: block;
`;

export const ToggleGroup = styled('div')`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 5px;
  width: fit-content;

  svg {
    height: 15px;
    width: 15px;
    stroke-width: 2;
  }
`;

export const Card = styled(Cards.Card)`
  align-items: stretch;
  border: 0.5px solid ${colours.neutral[200]};
  box-shadow: none;
  cursor: pointer;
  flex: 1;
  height: fit-content;
  justify-content: space-between;
  overflow: visible !important;

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1 1 100%;
    max-width: 100%;
    width: 100%;
  }
`;

export const ActiveConvosCard = styled(Card)`
  align-items: stretch;
  overflow: hidden;

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1 1 100%;
    max-width: 100%;
    width: 100%;
  }
`;

export const BottomBlur = styled('div')`
  background-image: linear-gradient(
    rgba(255, 0, 0, 0),
    rgba(255, 255, 255, 0.5),
    rgba(255, 255, 255, 0.95),
    rgba(255, 255, 255, 1)
  );
  bottom: 0;
  height: 60px;
  left: 0;
  position: absolute;
  width: 100%;
`;

export const Date = styled(Text.P1Semibold)`
  color: ${colours.neutral[600]} !important;
`;

export const Bold = styled('b')`
  font-weight: 500;
`;

export const DeleteIcon = styled('div')`
  padding: 0 0 10px 10px;
  &:hover {
    svg path {
      stroke: ${colours.primary[500]};
    }
  }
`;

export const Status = styled('div')<StatusProps>`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 5px;
  width: fit-content;

  p {
    color: ${(props) =>
      props.status === 'resolved' ? colours.mint[800] : colours.neutral[600]};
  }

  svg {
    height: 15px;
    width: 15px;
    stroke-width: 2;
  }

  svg path {
    stroke: ${(props) =>
      props.status === 'resolved' ? colours.mint[800] : colours.neutral[600]};
  }
`;

export const BottomSection = styled('div')`
  display: flex;
  gap: 15px;
  justify-content: space-between;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }
`;

export const StatusContainer = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const StatusChip = styled('div')`
  background-color: ${colours.neutral[600]};
  border-radius: 3px;
  height: fit-content;
  padding: 3px 10px;
  width: fit-content;

  p {
    color: white;
  }
`;

export const ResolvedStatusChip = styled(StatusChip)`
  background-color: ${colours.mint[200]};

  p {
    color: ${colours.mint[800]};
  }
`;

export const InProgressStatusChip = styled(StatusChip)`
  background-color: ${colours.warning[200]};

  p {
    color: black;
  }
`;

export const DraftStatusChip = styled(StatusChip)`
  background-color: ${colours.neutral[200]};

  p {
    color: ${colours.neutral[900]};
  }
`;

export const EmptyStateContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 30px;
  height: 100%;
  justify-content: center;
  margin: 100px 0;
  width: 100%;

  h6,
  p {
    color: ${colours.neutral[700]};
  }
`;

export const EmptyStateIcon = styled('img')`
  width: 220px;
`;

export const MigrationBanner = styled('div')`
  align-items: center;
  background-color: ${colours.neutral[100]};
  border: 2px solid ${colours.neutral[200]};
  border-radius: 30px;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  height: 60px;
  padding: 10px 10px 10px 20px;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: stretch;
    flex-direction: column;
    gap: 15px;
    height: auto;
    padding: 10px;
  }
`;

export const MigrationBannerContent = styled('div')`
  align-items: center;
  display: flex;
  flex: 1;
  gap: 10px;

  p {
    color: ${colours.neutral[600]};
  }

  svg {
    cursor: pointer;
    flex-shrink: 0;
    height: 20px;
    width: 20px;
    stroke-width: 2;
  }

  @media (max-width: ${breakpoints.tablet}) {
    align-items: flex-start;
    padding: 10px;
  }
`;
